<div id="gerador-ordem" class="page-layout simple">
    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div 
            class="header accent p-24" 
            fxLayout="row" 
            fxLayoutAlign="center center"
            fxLayoutAlign.gt-sm="space-between center"
        >       

            <!-- APP TITLE -->
            <div fxLayout="column" fxLayoutAlign="center start">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <mat-icon class="secondary-text s-18">home</mat-icon>
                    <mat-icon class="secondary-text s-16">chevron_right</mat-icon>
                    <span 
                        class="secondary-text pointer" 
                        style="cursor:  pointer;"
                        [routerLink]="'/renda-variavel/gerador-ordens/'">Gerador de Ordens
                    </span>
                </div>
                <div class="h1 mt-16" style="color: #fff !important;">{{titulo}}</div>
            </div>

            <div 
                class="add-product-button mb-24 mb-md-0" 
                fxLayout="row" 
                fxLayoutAlign="start center">                
               
            </div>
        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card" style="padding: 20px;">

            <mat-card> 
                <mat-card-header style="margin-bottom: 20px">
                    <mat-card-title>Cliente com Boletas Disponíveis</mat-card-title>
                    
                    <div fxLayoutAlign="center start">
                        <button 
                            mat-mini-fab                            
                            matTooltip="Adicionar/Remover Ativo(s)"
                            (click)="addAtivo()">
                            <mat-icon>add</mat-icon>
                        </button>

                        <button 
                            mat-mini-fab                            
                            matTooltip="Baixar Basket"
                            (click)="basket()">
                            <mat-icon>cloud_download</mat-icon>
                        </button>

                        <button 
                            mat-mini-fab           
                            color="warn"
                            matTooltip="Excluir Boletas"
                            (click)="delete()">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                    
                </mat-card-header>

                <mat-card-content>
                    <div 
                        class="tabela_principal mat-elevation-z8"
                        [ngClass]="{ 
                            'example-container-full': listaBoletaPendentes == false, 
                            'example-container': listaBoletaPendentes == true 
                        }" 
                    >
                        <table mat-table [dataSource]="rows">
                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef>
                                  <mat-checkbox 
                                    (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                                    [aria-label]="checkboxLabel()">
                                  </mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                  <mat-checkbox 
                                    (click)="$event.stopPropagation()"
                                    (change)="$event ? selection.toggle(row.id) : null"
                                    [checked]="selection.isSelected(row.id)"
                                    [aria-label]="checkboxLabel(row.id)">
                                  </mat-checkbox>
                                </td>
                                <th mat-footer-cell *matFooterCellDef></th>
                            </ng-container>
            
                            <ng-container matColumnDef="cliente">
                                <th mat-header-cell *matHeaderCellDef>Cliente</th>
                                <td mat-cell *matCellDef="let element"> {{element.cliente}} </td>
                                <td mat-footer-cell *matFooterCellDef> <b>Total: </b> {{totalClientes}} </td>
                            </ng-container>
            
                            <ng-container matColumnDef="valor_financeiro_bruto">
                                <th mat-header-cell *matHeaderCellDef>Financeiro Bruto</th>
                                <td mat-cell *matCellDef="let element"> R$ {{element.valor_financeiro_bruto | number : '1.2-2'}} </td>
                                <td mat-footer-cell *matFooterCellDef> <b>R$ {{getTotalBruto() | number : '1.2-2'}} </b></td>
                            </ng-container>
            
                            <ng-container matColumnDef="valor_financeiro_liquido">
                                <th mat-header-cell *matHeaderCellDef>Financeiro Liquido</th>
                                <td mat-cell *matCellDef="let element"> R$ {{element.valor_financeiro_liquido | number : '1.2-2'}} </td>
                                <td mat-footer-cell *matFooterCellDef> <b> R$ {{getTotalLiquido() | number : '1.2-2'}} </b></td>
                            </ng-container>
            
                            <ng-container [matColumnDef]="column" *ngFor="let column of newColumns">
                                <th mat-header-cell *matHeaderCellDef> 
                                    <span style="text-transform: uppercase">{{column}}</span> 
                                </th>
                                <td mat-cell *matCellDef="let element"> {{element[column] | number : '1.0-0'}} </td>
                                <td mat-footer-cell *matFooterCellDef> <b> </b></td>
                            </ng-container>          
                            
                            
                            <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                            <tr 
                                mat-row 
                                *matRowDef="let row; columns: columnsToDisplay;"
                                (click)="selection.toggle(row.id)"
                            >
                            </tr>
                            <tr mat-footer-row *matFooterRowDef="columnsToDisplay; sticky: true"></tr>
                        </table>
                    </div>
                </mat-card-content>
            </mat-card>

            <gerador-ordem-lista-pendente 
                [gerador_id]="data" 
                *ngIf="listaBoletaPendentes"
            >
            </gerador-ordem-lista-pendente>                
            

        </div>
    </div>
</div>